import { useCallback, useEffect, useState } from 'react';
import { SELECTED_AUDIO_OUTPUT_KEY } from '../../constants';
import { useDevices } from './useDevices';
export const useActiveAudioDevice = () => {
    var _a;
    const { audioOutputDevices } = useDevices();
    const [activeSinkId, _setActiveSinkId] = useState('default');
    const setActiveSinkId = useCallback((sinkId) => {
        window.localStorage.setItem(SELECTED_AUDIO_OUTPUT_KEY, sinkId);
        _setActiveSinkId(sinkId);
    }, []);
    useEffect(() => {
        const selectedSinkId = window.localStorage.getItem(SELECTED_AUDIO_OUTPUT_KEY);
        const hasSelectedAudioOutputDevice = audioOutputDevices.some((device) => selectedSinkId && device.deviceId === selectedSinkId);
        if (hasSelectedAudioOutputDevice) {
            _setActiveSinkId(selectedSinkId);
        }
    }, [audioOutputDevices]);
    return [
        {
            id: activeSinkId,
            label: (_a = audioOutputDevices.find((device) => device.deviceId === activeSinkId)) === null || _a === void 0 ? void 0 : _a.label
        },
        setActiveSinkId
    ];
};
//# sourceMappingURL=useActiveAudioDevice.js.map